import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import errorMsg from './errorMsg.js'
import Qs from 'qs'
import NProgress from 'nprogress'
import router from '@/router/index'
import {showLoading, hideLoading, showReadLoading, hideReadLoading} from './loading'
import { beginListRequest, finishListRequest } from './listRequestState'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API.indexOf('http') !== -1 ? process.env.BASE_API : window.location.origin + '/api', // api的base_url
  // baseURL: 'http://127.0.0.1/espier/public/index.php/api', // api的base_url
  timeout: 50000                  // 请求超时时间
})

async function transformConfig(config) {

  if (config.refreshToken && store.getters.token) {

    let timestamp = (Date.parse( new Date()))/1000
    if( Number(store.getters.exp) - timestamp <= 300 ) {
      await refreshSession()
    }
  }

  if (store.getters.token) {
    config.headers['Authorization'] = 'bearer ' + store.getters.token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  }

  config.transformRequest = function (data) {
    if (data && data.isUploadFile) {
      let params = new FormData()
      for (var key in data) {
        if (key !== 'isUploadFile') {
          params.append(key, data[key])
        }
      }
      return params
    } else {
      return Qs.stringify(data)
    }
  }

  return config
}

// request拦截器
function finishLoading (config) {
  if (config && config.usesGlobalLoading) {
    config.usesGlobalLoading = false
    hideLoading()
  }
  if (config && config.usesReadLoading) {
    config.usesReadLoading = false
    hideReadLoading()
  }
}

service.interceptors.request.use(config => {

  beginListRequest(config, router.currentRoute && router.currentRoute.fullPath)
  const isRead = (config.method || 'get').toLowerCase() === 'get'
  config.usesGlobalLoading = !config.notShowLoading && (!isRead || config.fullscreenLoading === true)
  config.usesReadLoading = !config.notShowLoading && isRead && !config.usesGlobalLoading
  if (config.usesGlobalLoading) {
    showLoading()
  }
  if (config.usesReadLoading) showReadLoading()

  return transformConfig(config).catch(error => {
    finishListRequest(config, true)
    finishLoading(config)
    return Promise.reject(error)
  })

}, error => {
  // Do something with request error
  finishListRequest(error.config, true)
  finishLoading(error.config)
  return Promise.reject(error)
})

// 刷新token
let refreshingSession
export function refreshSession () {
  if (refreshingSession) return refreshingSession
  const tokenAtStart = store.getters.token
  refreshingSession = service.get('/token/refresh', {
    notShowLoading: true,
    params: {
      token_refresh: true
    }
  }).then(function (response) {
    if (response.headers.authorization && store.getters.token === tokenAtStart) {
      store.dispatch('setToken', response.headers.authorization)
    }
  }).finally(() => { refreshingSession = null })
  return refreshingSession
}

// response拦截器
service.interceptors.response.use( response => {
  if (response.config.method != 'get') {
    // Message.closeAll()
  }
  finishListRequest(response.config)
  finishLoading(response.config)
  return response;
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
}, error => {
  finishListRequest(error.config, true)
  const loginPath = process.env.PREFIXES ? `/${process.env.PREFIXES}/login` : '/login'
  // Message.closeAll()
  var msg = ''
  const response = error.response
  const apiError = response && response.data && response.data.error || {}
  // 如果token已经过期，则刷新token
  if (apiError.message === 'The token has been blacklisted' || apiError.message === 'Token has expired') {
    msg = '当前页面已过期，请刷新'
  } else if (response && response.status === 403 && apiError.message == 'access denied, username password are not match') {
    msg = '用户名或密码错误'
  } else if (response && response.status === 403 && apiError.message == 'Token Signature could not be verified.') {
    router.push({path: loginPath})
    NProgress.done()
  } else {
    if (apiError.code && errorMsg['code' + apiError.code]) {
      msg = errorMsg['code' + apiError.code]
    } else {
      msg = apiError.message
    }
  }

  if(!msg) {
    msg = '系统繁忙，请重试'
  }

  if (!(error.config && error.config.quietError)) {
    Message({ message: msg, type: 'error', duration: 3 * 1000 })
  }

  finishLoading(error.config)
  return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js